import { render, staticRenderFns } from "./clientInvoices.vue?vue&type=template&id=ff57e5f0&scoped=true&"
import script from "./clientInvoices.vue?vue&type=script&lang=js&"
export * from "./clientInvoices.vue?vue&type=script&lang=js&"
import style0 from "./clientInvoices.vue?vue&type=style&index=0&id=ff57e5f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff57e5f0",
  null
  
)

export default component.exports